import { Link, useLocation } from '@tanstack/react-router';

export interface ILinkChildProps {
  link: string;
  label: string;
  disabled?: boolean;
  onClick?: () => void;
}
export const LinkChild: FC<ILinkChildProps> = ({ link = '', label, disabled = false, onClick }) => {
  const location = useLocation();

  // EWM-1041: `isActive` is a pure function of the current location and the `link` prop, so
  // it is computed during render instead of being mirrored into state by an effect. The
  // effect form painted every nav child as inactive first and only applied the highlight on
  // the following commit, so each navigation showed one frame with nothing highlighted.
  const isActive = location.pathname.includes(link);

  const handleClick = () => {
    onClick?.();
  };

  return (
    <Link
      disabled={disabled}
      to={link}
      onClick={handleClick}
      className={`${isActive ? 'bg-(--nav-item-bg) text-(--primary)' : 'text-(--text-secondary)'} hover:color-primary ${disabled ? 'cursor-default' : 'cursor-pointer'} my-[0.2rem] flex w-full rounded-lg pl-3 text-center text-sm font-bold hover:bg-(--nav-item-bg)`}
    >
      <p className='flex justify-items-center px-3 py-[6px] whitespace-nowrap'>{label}</p>
    </Link>
  );
};
